import Header from './containers/Header'

window.argosHeaderService = {
  component: Header,
}
